import { BlocksIconFile } from 'blocks-nextjs/blocks-web-components/components/icon/icons/file';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconFile = createComponent({ react: React, tagName: 'cat-icon-file', elementClass: BlocksIconFile });
